import { default as React, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import TagsField from '../../../core/components/Fields/TagsField.tsx';
import FormField from '../../../core/components/FormField.tsx';
import SaveStatus from '../../../core/components/SaveStatus.tsx';
import SettingsFormCard from '../../../core/components/SettingsFormCard.tsx';
import { useToaster } from '../../../core/components/Toast.tsx';
import countFieldErrors from '../../../core/utils/countFieldErrors.ts';

const FORM_DEFAULT_VALUES = {
    highlightKeywords: [] as string[],
};

const parseKeywordList = (value?: string | null): string[] => {
    try {
        const parsed = JSON.parse(value || '[]');
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
};

const ListOfServicesKeywordsConfig = ({ config, onSubmit }) => {
    const { t } = useTranslation('config');
    const { publishToast } = useToaster();

    const form = useForm({ defaultValues: FORM_DEFAULT_VALUES, mode: 'onTouched' });

    useEffect(() => {
        form.reset({ highlightKeywords: parseKeywordList(config?.highlightKeywordList) });
    }, [config]);

    const handleSubmit = async (formData) => {
        try {
            await onSubmit({ highlightKeywordList: formData.highlightKeywords });
            publishToast({ description: t('configPage.keywords.updateSuccess'), status: 'success' });
        } catch (e) {
            console.error(e);
            publishToast({ description: t('configPage.keywords.updateError'), status: 'error' });
        }
    };

    return (
        <SettingsFormCard
            onSubmit={form.handleSubmit(handleSubmit)}
            title={t('configPage.keywords.title')}
            description={t('configPage.keywords.description')}
        >
            <Controller
                name="highlightKeywords"
                control={form.control}
                render={({ field }) => (
                    <FormField
                        label={t('configPage.keywords.form.highlightKeywords')}
                        helpText={t('configPage.keywords.form.highlightKeywordsDescription')}
                    >
                        <TagsField {...field} onValueChange={field.onChange} separator=";" />
                    </FormField>
                )}
            />

            <SaveStatus
                isDirty={form.formState.isDirty}
                isSubmitting={form.formState.isSubmitting}
                errorCount={countFieldErrors(form.formState.errors)}
            />
        </SettingsFormCard>
    );
};

export default ListOfServicesKeywordsConfig;
